__turbopack_context__.v({
  "root": "SimpleButton-module-scss-module__MOTZpG__root" + " " + __turbopack_context__.i(26191)["simpleLink"],
});
